<ng-container *transloco="let t; read: 'ALLERGENS_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header moderate-background with-handle">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>
  <ion-content class="ion-padding">
    <div class="mentions-legales" [innerHTML]="t('MENTIONS_LEGALES')"></div>
  </ion-content>
</ng-container>
